<div class="dso__page-heading">
  <h1 class="dso__page-title" id="dso-page-heading">
    {{ heading | titleclean | titlecaseExcept }}
  </h1>
</div>
